import { Injectable, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import * as CryptoJS from 'crypto-js';
@Injectable({
  providedIn: 'root'
})
export class UsersService  {

private secretKey = environment.AES_SECRET;


private encryptData(data: any): string {
  return CryptoJS.AES.encrypt(JSON.stringify(data), this.secretKey).toString();
}

private decryptData(encryptedData: string): any {
  const bytes = CryptoJS.AES.decrypt(encryptedData, this.secretKey);
  return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
}

  private baseUrl = environment.apiURL;
  constructor(private http: HttpClient) { }
  userData = null

  getUsers() {
    return this.http.get(this.baseUrl + environment.apiEndPoints.getUsersList).pipe(map(data => {
      this.userData = data
      return data;
    }));
  }

  getUsersByDept(id) {
    return this.http.get(this.baseUrl + environment.apiEndPoints.getUsersListByDept+"?dept="+id).pipe(map(data => {
      return data;
    }));
  }

  createUser(user){
    return this.http.post(this.baseUrl + environment.apiEndPoints.createUser,user).pipe(map(data=>{
      return data;
    }))
  }
// changepassword(data){
//   return this.http.post(this.baseUrl + environment.apiEndPoints.changepassword,data).pipe(map(data=>{
//     return data;
//   }))
// }

changepassword(data: any) {
  const encryptedPayload = {
    encryptedData: this.encryptData(data)
  };

  return this.http.post(this.baseUrl + environment.apiEndPoints.changepassword, encryptedPayload).pipe(
    map((response: any) => {
      if (!response.status) {
        const decryptedError = this.decryptData(response.data);
        throw decryptedError;
      }
      
      const decryptedResponse = this.decryptData(response.data);
      return decryptedResponse;
    }),
    catchError((error) => {
      if (error.error && error.error.data) {
        try {
          const decryptedError = this.decryptData(error.error.data);
          return throwError(decryptedError);
        } catch (e) {
          return throwError(error);
        }
      }
      return throwError(error);
    })
  );
}
  getRoles(){
    return this.http.get(this.baseUrl + environment.apiEndPoints.getRoles).pipe(map(data=>{
      return data;
    }))
  }

  getRoleDetailsById(id){
    return this.http.get(this.baseUrl + environment.apiEndPoints.getRoleDetailsById+"?id="+id).pipe(map(data=>{
      return data;
    }))
  }

  updatePermissions(roleDetails){
    return this.http.post(this.baseUrl + environment.apiEndPoints.UpdatePermissions,roleDetails).pipe(map(data=>{
      return data;
    }))
  }
  
  getUserDetailsById(id){
    return this.http.get(this.baseUrl + environment.apiEndPoints.getUserDetails+"?id="+id).pipe(map(data=>{
      return data;
    }))
  }

  updateUser(user){
    return this.http.post(this.baseUrl + environment.apiEndPoints.UpdateUser,user).pipe(map(data=>{
      return data;
    }))
  }

  UpdateUserPass(user){
    console.log("Came to service")
    return this.http.post(this.baseUrl + environment.apiEndPoints.UpdateUserPass,user).pipe(map(data=>{
      return data;
    }))
  }

  

  permissionsdata(){
    return JSON.parse(sessionStorage.getItem('role_permissions'));
  }

  getMasters(data) {
    return this.http.post(this.baseUrl + environment.apiEndPoints.getMasters, data).pipe(map(data => {
      return data;
    }));
  }
  
}
